const PlusIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10.25c0-5.524 4.476-10 10-10s10 4.476 10 10-4.476 10-10 10-10-4.476-10-10zm18.286 0c0-4.571-3.715-8.286-8.286-8.286S1.714 5.68 1.714 10.25 5.43 18.536 10 18.536s8.286-3.715 8.286-8.286zm-7.143 5.714h-2v-4.762H4.38V9.298h4.762V4.536h2v4.666h4.666v2h-4.666v4.762z"
      fill="currentColor"
    />
  </svg>
)

export default PlusIcon
